// src/components/FadeInOut.js
import React, {useEffect, useState} from "react";

const UNMOUNTED = "unmounted";
const EXITED = "exited";
const ENTERING = "entering";
const ENTERED = "entered";
const EXITING = "exiting";

const transitionStyles = {
    entering: {opacity: 0},
    entered: {opacity: 1},
    exiting: {opacity: 0},
    exited: {opacity: 0}
};

const FadeInOut = ({show = false, duration = 300, children, className, style = {}}) => {
    // 初始狀態根據 show 決定，如果第一次就 show，則直接顯示；否則 UNMOUNTED（但我們會 render 出來，只是 display: "none"）
    const [status, setStatus] = useState(show ? ENTERED : UNMOUNTED);

    useEffect(() => {
        if (show) {
            if (status !== ENTERING && status !== ENTERED) {
                performEnter();
            }
        } else {
            if (status === ENTERING || status === ENTERED) {
                performExit();
            }
        }
    }, [show]);

    useEffect(() => {
        if (!show && status === EXITED) {
            // 不移除元件，而是將狀態設為 UNMOUNTED，這邊 UNMOUNTED 就代表 display: none
            setStatus(UNMOUNTED);
        }
    }, [show, status]);

    const performEnter = () => {
        setStatus(ENTERING);
        setTimeout(() => {
            setStatus(ENTERED);
        }, duration);
    };

    const performExit = () => {
        setStatus(EXITING);
        setTimeout(() => {
            setStatus(EXITED);
        }, 0);
    };

    return (
        <div
            className={className}
            style={{
                display: status === UNMOUNTED ? "none" : "block",
                transition: `opacity ${duration}ms ease-in-out`,
                ...transitionStyles[status],
                ...style
            }}
        >
            {children}
        </div>
    );
};

export default FadeInOut;
